<ngx-ui-loader [fgsType]="spinnerType" logoUrl="./assets/icons/atom_logo.svg">
</ngx-ui-loader>
<router-outlet></router-outlet>